/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Total_FloorsInputs */

const cs_form_total_floors = /** @type {(inputs: Form_Total_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet podlaží`)
};

const en_form_total_floors = /** @type {(inputs: Form_Total_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total floors`)
};

/**
* | output |
* | --- |
* | "Total floors" |
*
* @param {Form_Total_FloorsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_total_floors = /** @type {((inputs?: Form_Total_FloorsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Total_FloorsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_total_floors(inputs)
	return cs_form_total_floors(inputs)
});